import { http } from "../httpHandler";
import { links } from "@/constants";
import { TServerErrorResponse } from "@/types/errors";

export const postEmailDraft = async (payload: {
  installedIntegrationId: string;
  to: string[];
  cc: string[];
  subject: string;
  body: string;
}): Promise<{ openUrl: string }> => {
  try {
    const response = await http.post<{ openUrl: string }>(
      links.emailDraft.index,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
